// Sticky header hide
const header = document.querySelector('.header-wrapper');
header.classList.add('fixed_header');
let justReloaded = false;

window.addEventListener('load', function () {
  const navEntry = performance.getEntriesByType("navigation")[0];
  const isReload = performance.navigation.type === 1 || (navEntry && navEntry.type === "reload");

  const initial = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
// console.log(initial, "initial")

  if (isReload && initial > 99 ) {
    header.classList.add('reloaded');
    justReloaded = true;
      justReloaded = false;
  }
});

function updateHeaderOnScroll() {
  const currentScroll = window.scrollY;
  if (currentScroll > 100 && !justReloaded) {
    header.classList.add('hide');
  } else {
    header.classList.remove('hide');
  }
  if (currentScroll === 0) {
    header.classList.remove('reloaded');
  }
}
window.addEventListener('scroll', updateHeaderOnScroll);


// const header = document.querySelector('.header-wrapper');
// if (header) {
//   header.classList.add('fixed_header');

//   // Add .reloaded on initial load if already scrolled >= 100
//   window.addEventListener('load', () => {
//     requestAnimationFrame(() => {
//       const initial = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
//       if (initial >= 100) header.classList.add('reloaded');
//     });
//   });

//   // Hide on scroll down, show on scroll up
//   let lastScroll = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);

//   function updateHeaderOnScroll() {
//     const current = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
//     const scrollingDown = current > lastScroll;

//     if (scrollingDown && current > 50) {
//       header.classList.add('hide');
//     } else {
//       header.classList.remove('hide');
//     }

//     // When back to very top, clear "reloaded"
//     if (current === 0) {
//       header.classList.remove('reloaded');
//     }

//     lastScroll = current;
//   }

//   window.addEventListener('scroll', updateHeaderOnScroll, { passive: true });
// }






// ScrollTop Header visibility JS
// let lastScrollTop = 0;
// $(window).scroll(function() {
// const currentScroll = window.scrollY;
// let currentScrollTop = $(this).scrollTop();

// if (currentScroll > 100) {
//   if (currentScrollTop < lastScrollTop) {
//     $('.header-wrapper.fixed_header').addClass('activate_header');
//   } else if (currentScrollTop > lastScrollTop) {
//     $('.header-wrapper.fixed_header').removeClass('activate_header');
//   }
// } else{
//   $('.header-wrapper.fixed_header').removeClass('activate_header');
// }
//   lastScrollTop = currentScrollTop;
// });